// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iRMN","toggleWrap":"styles_toggleWrap__2G7Ka","content":"styles_content__39uVe","selectAreaCode":"styles_selectAreaCode__2gitL"};